// extracted by mini-css-extract-plugin
export default {"exclamation-icon-watchlist":"exclamation-icon-watchlist","notification-column":"notification-column","notification-column-container":"notification-column-container","action-badge":"action-badge","ant-badge-count":"ant-badge-count","ant-scroll-number-only":"ant-scroll-number-only"};
    if(module.hot) {
      // 1790857688814
      var cssReload = require("/home/vsts/work/1/s/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  